export const Drawer = {
  variants: {
    sidenav: {
      dialog: {
        maxWidth: "225px",
      },
    },
  },
};
